const useApplicationMessageEvents = (
  track: (
    event: FimTrackingEvent,
    payload: FimTrackingPayload,
    options?: MapToTrackingPayloadOptions,
  ) => any,
) => {
  return {
    trackApplicationMessage: (payload: ApplicationTrackingPayload) => {
      track('FielmannBasic_ApplicationMessage', payload)
    },
    trackApplicationError: (payload: ApplicationTrackingPayload) => {
      track('FielmannBasic_ApplicationError', payload)
    },
  }
}

export default useApplicationMessageEvents

export type ApplicationTrackingPayload = {
  applicationChild: {
    id: string
    route: string
  }
  message?: {
    title: string
    details: string
  }
  error?: {
    title: string
    details: string
  }
}
